export default function certificateSlider() {

    const certificateSlider = document.querySelector('.js-certificateSlider');

    if (!certificateSlider) {
        return false;
    }

    function initcertificateSlider() {

        if (certificateSlider.childElementCount == 1) {
            return false;
        }

        if (certificateSlider.childElementCount <= 4 && window.innerWidth > 1200) {
            return false;
        }

        if (certificateSlider.childElementCount <= 2 && window.innerWidth <= 1200 && window.innerWidth > 540) {
            return false;
        }

        $('.js-certificateSlider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            dotsClass: 'certificate_dots',
            prevArrow: '<button type="button" class="certificate_arrow-prev"></button>',
            nextArrow: '<button type="button" class="certificate_arrow-next"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initcertificateSlider);

}